export default "/images/c6be9b27cabf1be32f31906b2fc6a034.png";